import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AppConfig } from '@mkp/shared/util-app-config';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { selectIsBoUser, selectIsUserRole } from '@mkp/user/state-logged-in/selectors';
import { concatLatestFrom } from '@ngrx/operators';
import { UserRole } from '@mkp/user/models';
import { selectWorkspaceFromUrlStatus, WorkspaceFromUrlStatus } from '@mkp/auth/state';
import { selectActiveAccounts } from '@mkp/account/state';

const { routes } = AppConfig;

export const activeUserGuard: () => Observable<true | UrlTree> = () => {
  const store = inject(Store);
  const router = inject(Router);

  return hasAccountMembershipOperator(store).pipe(
    map((hasAccountMembership) => hasAccountMembership || router.parseUrl(routes.claimCompany))
  );
};

const hasAccountMembershipOperator = (store: Store): Observable<boolean> =>
  store.select(selectWorkspaceFromUrlStatus).pipe(
    filter((status) => status !== WorkspaceFromUrlStatus.INIT),
    concatLatestFrom(() => [
      store.select(selectActiveAccounts).pipe(map((accounts) => accounts.length)),
      store.select(selectIsBoUser),
      store.select(selectIsUserRole(UserRole.SuperAdmin)),
    ]),
    take(1),
    map(([, accountCount, isBoUser, isSuperAdmin]) => isBoUser || isSuperAdmin || accountCount > 0)
  );
